import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';

@Component({
  selector: 'app-onboarding-list',
  templateUrl: './onboarding-list.component.html',
  styleUrls: ['./onboarding-list.component.css']
})
export class OnboardingListComponent implements OnInit {
  subscription: Subscription;
  @Output() searchItem: EventEmitter<any> = new EventEmitter();
  searchInvoiceAdapter: any;
  isShowAddEmp: boolean = true;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    private router: Router, private property: PropertiesService) {
    this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
      this.getGridData();
    });
  }

  ngOnInit() {
    console.log(this.property.roleId);
    this.getGridData();
    if (this.property.roleId == this.property.DefaultRoleId || this.property.userId == 33 || this.property.userId == 2311 || this.property.userId == 2224) {
      this.isShowAddEmp = false;
    }
  }

  ngAfterViewInit(): void {
    this.getGridData();
  }

  searchInvoiceColumns: any[] =
    [
      {
        text: 'S.No', width: '5%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
          return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
        }
      },
      { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
      { text: 'Emp No.', datafield: 'EmployeeNumber', width: '10%' },
      { text: 'Name', datafield: 'EmployeeName', width: '20%' },
      { text: 'Designation', datafield: 'Designation', width: '15%' },
      { text: 'Branch', datafield: 'Branch', width: '10%' },
      { text: 'DOJ', datafield: 'DOJ', width: '10%', cellsformat: "dd/MM/yyyy" },
      { text: 'Email', datafield: 'Email', width: '20%' },
      { text: 'MobileNumber', datafield: 'MobileNumber', width: '10%' },
     
    ];

  searchInvoiceSource: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'TransID', type: 'int' },
        { name: 'EmployeeNumber', type: 'string' },
        { name: 'EmployeeName', type: 'string' },
        { name: 'Designation', type: 'string' },
        { name: 'Branch', type: 'string' },
        { name: 'DOJ', type: 'string' },
        { name: 'Email', type: 'string' },
        { name: 'MobileNumber', type: 'string' },
      ],
      id: 'invoiceid',
      localdata: ''
    };
  getGridData() {
    this.getData().then((list: any) => {
      this.searchInvoiceSource.localdata = list.result;
      this.searchInvoiceAdapter = new jqx.dataAdapter(this.searchInvoiceSource);
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/OnboardingRequest/LOV_OnboardingRequest")
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  RowclickInvoiceSearch(event: any): void {
    var args = event.args;
    if (this.property.roleId == this.property.DefaultRoleId || this.property.userId == 33 || this.property.userId == 2311 || this.property.userId == 2224) {

      var selectedRowIndex = args.rowindex;
      this.searchItem.emit();
      args.row.bounddata.timestamp = new Date().getTime();
      console.log(args);
      this.router.navigate(['home/Onboarding'], { queryParams: args.row.bounddata });
    } else if (args.row.bounddata.isSelf == 1) {
      //  var args = event.args;
      var selectedRowIndex = args.rowindex;
      this.searchItem.emit();
      args.row.bounddata.timestamp = new Date().getTime();
      console.log(args);
      this.router.navigate(['home/Onboarding'], { queryParams: args.row.bounddata });
    }


  }
}
